module.exports = __webpack_public_path__ + "static/fig3-1a20f235e0ae39703608a46116d37c03.jpg";